export class KeyboardEventUtils {

  static readonly KEY_ARROW_UP = 'ArrowUp';
  static readonly KEY_ARROW_DOWN = 'ArrowDown';
  static readonly KEY_ARROW_LEFT = 'ArrowLeft';
  static readonly KEY_ARROW_RIGHT = 'ArrowRight';
  static readonly KEY_PAGE_DOWN = 'PageDown';
  static readonly KEY_PAGE_UP = 'PageUp';
  static readonly KEY_HOME = 'Home';
  static readonly KEY_END = 'End';

  static readonly KEY_ESCAPE = 'Escape';
  static readonly KEY_ENTER = 'Enter';
  static readonly KEY_BACKSPACE = 'Backspace';
  static readonly KEY_CONTROL = 'Control';
  static readonly KEY_META = 'Meta';

  static readonly VALUE_KEYS = new Set('abcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*(){}?+_"<>,.`~\'-=/=\\ '.split(''))


  /** These are `keyCode` values. `keyCode` property is deprecated. Used only in mention directive workaround because
   * the library methods check `keyCode` and the workaround in making backspace work for Android keyboard involves
   * creating a fake keyboard event and passing to its keyHandler. */
  static readonly KEYCODE_BACKSPACE = 8;
  static readonly KEYCODE_BUFFERED = 229;
}
